require("core-js/modules/es6.function.bind");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;
var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("helix.impl.classes.js");
goog.provide("helix.impl.classes");

helix.impl.classes.createComponent = function createComponent(superclass, spec, statics) {
  var helix$impl$classes$classdecl$var0 = function helix$impl$classes$classdecl$var0(props) {
    var $jscomp$super$this;
    $jscomp$super$this = superclass.call(this, props) || this;

    if (spec.constructor) {
      spec.constructor.call($jscomp$super$this, $jscomp$super$this);
    }

    for (var key in spec) {
      if (key !== "constructor") {
        var prop = spec[key];

        if (typeof prop === "function") {
          $jscomp$super$this[key] = prop.bind($jscomp$super$this, $jscomp$super$this);
        } else {
          $jscomp$super$this[key] = prop;
        }
      }
    }

    return $jscomp$super$this;
  };

  $jscomp.inherits(helix$impl$classes$classdecl$var0, superclass);
  var component = helix$impl$classes$classdecl$var0;

  for (var key in statics) {
    var prop = statics[key];

    if (typeof prop === "function") {
      component[key] = prop.bind(component, component);
    } else {
      component[key] = prop;
    }
  }

  return component;
};

module.exports = helix.impl.classes;